export default __webpack_public_path__ + "static/media/advcoruja-forgotpassword.213831ac.png";